export const isNullOrUndefined = <T>(value: T | null | undefined): value is null | undefined => value === null || value === undefined;
export const isNotNullOrUndefined = <T>(value: T | null | undefined): value is T => value !== null && value !== undefined;
export const isNotBlank = (value: any) => value !== undefined && value !== null && `${value}`.length > 0;
export const isBlank = (value: any) => !isNotBlank(value);
export const isValidString = (str: string | null | undefined): boolean => !!str && str.trim().length > 0;
